import React from 'react'

import { array } from 'prop-types'

import SubcategoryCard from './SubcategoryCard'

function SubcategoriesGrid({ subcategories }) {
  return (
  <div className="categories-section__subcategories">
    {subcategories?.map((subcategory) => (
      <SubcategoryCard key={subcategory.slug} subcategory={subcategory} />
    ))}
  </div>
  )
}

SubcategoriesGrid.propTypes = {
  subcategories: array.isRequired,
}

export default SubcategoriesGrid
